import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut } from "lucide-react";

export default function DashboardShell({ title, nav, children }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const doLogout = () => {
        logout();
        navigate("/");
    };

    return (
        <div className="min-h-screen bg-slate-50 flex">
            {/* Sidebar */}
            <aside className="w-64 bg-[#0B192C] text-white p-6 hidden md:flex flex-col sticky top-0 h-screen">
                <div className="flex items-center gap-2 mb-10">
                    <div className="w-9 h-9 rounded-xl bg-[#F5A623] flex items-center justify-center">
                        <span className="text-[#0B192C] font-black text-lg font-display">R</span>
                    </div>
                    <div className="font-display text-lg font-black">Renforteo</div>
                </div>
                <div className="overline text-white/50 mb-3">{title}</div>
                <nav className="space-y-1">
                    {nav.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.end}
                            className={({ isActive }) =>
                                `sd-nav-item ${isActive ? "active" : ""}`
                            }
                            data-testid={`sidebar-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                        >
                            <n.icon size={18} />
                            <span>{n.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="mt-auto pt-8 border-t border-white/10">
                    <div className="text-xs text-white/60 mb-3 truncate">
                        {user?.full_name || user?.email}
                    </div>
                    <button
                        onClick={doLogout}
                        className="sd-nav-item w-full"
                        data-testid="sidebar-logout"
                    >
                        <LogOut size={18} />
                        <span>Se déconnecter</span>
                    </button>
                </div>
            </aside>
            {/* Content */}
            <div className="flex-1 min-w-0">
                {/* Mobile top */}
                <div className="md:hidden glass sticky top-0 z-30 p-4 flex justify-between items-center">
                    <div className="font-display font-black">Renforteo · {title}</div>
                    <button onClick={doLogout} className="text-slate-500">
                        <LogOut size={18} />
                    </button>
                </div>
                <main className="p-6 md:p-10 max-w-6xl">{children}</main>
            </div>
        </div>
    );
}
